import React from "react";
import Icon from "../../assets/Icon";

function TranscriptNavbar({ config }) {
  return (
    <div className="bg-[#F2F8FE] px-3 py-[.88rem] min-[920px]:py-[.68rem] shadow-md relative flex justify-center items-center w-full">
      {config && (
        <div className="static min-[680px]:absolute left-[1.3%]">
          {config?.whiteLabelingRequired ? (
            <img
              alt="logo"
              // src="https://hireplusplus-public-de.s3.eu-central-1.amazonaws.com/thubLogo/Logo.png"
              src={config?.whiteLabelingLink}
              className="w-[75px] md:w-[90px]"
              onError={(e) => {
                e.target.onerror = null; // Prevents infinite loop in case the fallback fails
                e.target.style.display = "none"; // Hides the broken image
                e.target.nextSibling.style.display = "block"; // Shows the default icon
              }}
            />
          ) : (
            <Icon type="hire-logo" width="88" height="50" />
          )}
          <div style={{ display: "none" }}>
            <Icon type="hire-logo" width="88" height="50" />
          </div>
        </div>
      )}
      <div className="text-end min-[540px]:text-center text-[#101828] w-full">
        <div className="text-[1.15rem] sm:text-[1.3rem] font-semibold">
          Transcription Analysis
        </div>
        <div className="text-[.82rem] sm:text-[.86rem] leading-[1.15rem]">
          AI Assessment Report by Hire++{" "}
          <span className="transcript-nav-footer lg:inline hidden">
            | © HirePlusPlus Technologies Private Limited. All Rights Reserved.
          </span>
        </div>
      </div>
    </div>
  );
}

export default TranscriptNavbar;
